module.exports = {
    tag: 'a:prstGeom',
    $: {prst: 'rect'},
    c: [{tag: 'a:avLst'}],
}